/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="z-[5] mx-auto flex w-full max-w-screen-sm flex-col items-center justify-between px-[20px] pb-4 lg:mb-6 lg:max-w-[100%] lg:flex-row xl:mb-2 xl:w-[1310px] xl:pb-6">
      <p className="mb-6 text-center text-sm text-gray-600 md:text-base lg:mb-0">
        ©{1900 + new Date().getYear()} <span className="text-blue-1000">hypertrace.io</span>
      </p>
      <ul className="flex flex-wrap items-center sm:flex-nowrap">
        <li className="mr-12">
          <Link to="/admin/support" className="text-sm text-gray-600 hover:text-blue-1000 md:text-base lg:blue-1000 lg:hover:gray-600">
            Support
          </Link>
        </li>
        <li className="mr-12">
          <Link to="/admin/license" className="text-sm text-gray-600 hover:text-blue-1000 md:text-base lg:blue-1000 lg:hover:gray-600">
            License
          </Link>
        </li>
        <li className="mr-12">
          <Link to="/admin/terms-of-use" className="text-sm text-gray-600 hover:text-blue-1000 md:text-base lg:blue-1000 lg:hover:gray-600">
            Terms of Use
          </Link>
        </li>
        <li>
          <Link to="/admin/blog" className="text-sm text-gray-600 hover:text-blue-1000 md:text-base lg:blue-1000 lg:hover:gray-600">
            Blog
          </Link>
        </li>
      </ul>
    </div>
  );
}
